export const COMMON_SET_DEFAULT_LANGUAGE = 'COMMON_SET_DEFAULT_LANGUAGE';
